module.exports = __webpack_public_path__ + "static/media/rocket.81ebdaf5.svg";